import { render, staticRenderFns } from "./commercialCarPriceForm.vue?vue&type=template&id=6ffd1f5e&scoped=true&"
import script from "./commercialCarPriceForm.vue?vue&type=script&lang=js&"
export * from "./commercialCarPriceForm.vue?vue&type=script&lang=js&"
import style0 from "./commercialCarPriceForm.vue?vue&type=style&index=0&id=6ffd1f5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffd1f5e",
  null
  
)

export default component.exports